/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/11
 */
export const GET_PRODUCT_OPTIONS = 'GET_PRODUCT_OPTIONS';
export const RECEIVE_PRODUCT_OPTIONS = 'RECEIVE_PRODUCT_OPTIONS';
export const SELECT_OPTION = 'SELECT_OPTION';
export const TO_EVALUATE = 'TO_EVALUATE';
export const RECEIVE_EVALUATE = 'RECEIVE_EVALUATE';
export const UPDATE_EXPRESS_TYPE = 'UPDATE_EXPRESS_TYPE';
export const ACCEPT_PROTOCOL = 'ACCEPT_PROTOCOL';
export const UPDATE_FORM_INPUT = 'UPDATE_FORM_INPUT';
export const UPDATE_ADDRESS = 'UPDATE_ADDRESS';
export const TO_ORDER = 'TO_ORDER';
export const RECEIVE_ORDER_INFO = 'RECEIVE_ORDER_INFO';
export const UPDATE_BUTTON_STATUS = 'UPDATE_BUTTON_STATUS';

export const getProductOptions = (pid) => {
  return {
    type: GET_PRODUCT_OPTIONS,
    pid
  }
};

export const receiveProductOptions = data => {
  return {
    type: RECEIVE_PRODUCT_OPTIONS,
    data
  }
};

export const selectOption = (id, value, name, types) => {
  return {
    type: SELECT_OPTION,
    id,
    value,
    name,
    types
  }
};

export const toEvaluate = payload => {
  return {
    type: TO_EVALUATE,
    payload
  };
};

export const receiveEvaluate = (selectedStrings, evaluatedOptions) => {
  return {
    type: RECEIVE_EVALUATE,
    selectedStrings,
    evaluatedOptions
  };
};

export const updateExpressType = pickupType => {
  return {
    type: UPDATE_EXPRESS_TYPE,
    pickupType
  };
};


export const acceptProtocol = () => {
  return {
    type: ACCEPT_PROTOCOL
  }
};

export const updateFormInput = (name, value) => {
  return {
    type: UPDATE_FORM_INPUT,
    name,
    value
  }
};

export const updateAddress = data => {
  return {
    type: UPDATE_ADDRESS,
    data
  }
};

export const toOrder = payload => {
  return {
    type: TO_ORDER,
    payload
  };
};

export const receiveOrderInfo = (data, payload) => {
  return {
    type: RECEIVE_ORDER_INFO,
    data,
    payload
  }
};

export const updateButtonStatus = isButtonForbid => {
  return {
    type: UPDATE_BUTTON_STATUS,
    isButtonForbid
  }
}



// WEBPACK FOOTER //
// ./src/actions/step.js